import React from 'react';
import PropTypes from 'prop-types';
import * as S from './invalid-route-styled';

export const ErrorPage = ({ title, message }) => {
  return (
    <S.Container>
      <S.StyledErrorContainer>
        <S.StyledTitle>{title}</S.StyledTitle>
        {message && <S.StyledMessage>{message}</S.StyledMessage>}
      </S.StyledErrorContainer>
    </S.Container>
  );
};

ErrorPage.propTypes = {
  title: PropTypes.node,
  message: PropTypes.node
};
